import { GET } from "Common/api";
import config from "lib/config";

/**
 * Fetches categories data from the API
 * @returns {Promise<Array>} Promise resolving to array of categories
 */
export const fetchCategories = async () => {
  const categories = await GET(
    `v1/internal/learning/catalogue/categories/${config.siteId}`,
  );
  return categories;
};

/**
 * Fetches catalogue data from the API
 * @param {boolean} isPublic - Whether to use public endpoint (default: false)
 * @returns {Promise<Array>} Promise resolving to array of courses
 */
export const fetchCatalogue = async (isPublic = false) => {
  const endpoint = isPublic
    ? `v1/internal/learning/opencatalogue/${config.siteId}`
    : `v1/internal/learning/catalogue/${config.siteId}`;
  const response = await GET(endpoint);
  return response;
};
